var moduleMap = {
	"./default": function() {
		return __webpack_require__.e(4704).then(function() { return function() { return (__webpack_require__(24704)); }; });
	},
	"./Accreditation": function() {
		return __webpack_require__.e(3539).then(function() { return function() { return (__webpack_require__(43539)); }; });
	},
	"./AntiFraud": function() {
		return __webpack_require__.e(1638).then(function() { return function() { return (__webpack_require__(61638)); }; });
	},
	"./Authentication": function() {
		return __webpack_require__.e(5205).then(function() { return function() { return (__webpack_require__(55205)); }; });
	},
	"./BankSlip": function() {
		return __webpack_require__.e(9192).then(function() { return function() { return (__webpack_require__(19192)); }; });
	},
	"./BankslipTax": function() {
		return __webpack_require__.e(1738).then(function() { return function() { return (__webpack_require__(77909)); }; });
	},
	"./Charge": function() {
		return __webpack_require__.e(9418).then(function() { return function() { return (__webpack_require__(79418)); }; });
	},
	"./Chargeback": function() {
		return __webpack_require__.e(2955).then(function() { return function() { return (__webpack_require__(42955)); }; });
	},
	"./Checkout": function() {
		return __webpack_require__.e(1491).then(function() { return function() { return (__webpack_require__(31491)); }; });
	},
	"./FirstSteps": function() {
		return __webpack_require__.e(9456).then(function() { return function() { return (__webpack_require__(79456)); }; });
	},
	"./Gateway": function() {
		return __webpack_require__.e(7385).then(function() { return function() { return (__webpack_require__(57385)); }; });
	},
	"./Integration": function() {
		return __webpack_require__.e(631).then(function() { return function() { return (__webpack_require__(50631)); }; });
	},
	"./Invoices": function() {
		return __webpack_require__.e(1449).then(function() { return function() { return (__webpack_require__(21449)); }; });
	},
	"./PaymentLink": function() {
		return __webpack_require__.e(8974).then(function() { return function() { return (__webpack_require__(88974)); }; });
	},
	"./PIX": function() {
		return __webpack_require__.e(1448).then(function() { return function() { return (__webpack_require__(41448)); }; });
	},
	"./ProtectedCard": function() {
		return __webpack_require__.e(9248).then(function() { return function() { return (__webpack_require__(9248)); }; });
	},
	"./Reconciliation": function() {
		return __webpack_require__.e(9397).then(function() { return function() { return (__webpack_require__(49397)); }; });
	},
	"./Recurrency": function() {
		return __webpack_require__.e(4992).then(function() { return function() { return (__webpack_require__(84992)); }; });
	},
	"./Settling": function() {
		return __webpack_require__.e(652).then(function() { return function() { return (__webpack_require__(60652)); }; });
	},
	"./Taxes": function() {
		return __webpack_require__.e(9086).then(function() { return function() { return (__webpack_require__(89086)); }; });
	},
	"./TEF": function() {
		return __webpack_require__.e(5330).then(function() { return function() { return (__webpack_require__(65330)); }; });
	},
	"./Webhook": function() {
		return __webpack_require__.e(6178).then(function() { return function() { return (__webpack_require__(36178)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});